<script>
export default {
  name: "AcceptOrganizationInvitation",
  created() {
    this.axios.put(this.$store.getters.getUrl('acceptInvitation'), this.$route.params.token).then(() => {
      this.$store.dispatch('addNotification',
          {
            type: 'success',
            message: this.$t('success.invitationAcceptSuccessful')
          });
    }).finally(() => {
      this.$router.push({name: 'login'});
    });
  },
};
</script>
